import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkApi } from '../index.d'
import { GridSaveParams, GridServerResponse, GridViewParams } from '@lk/api'

export const viewGrid = createAsyncThunk<GridServerResponse, GridViewParams, ThunkApi>(
  '[GRID] VIEW',
  async ({ formName, objectName }, { extra, rejectWithValue }) => {
    const result = await extra.api.grids.get(formName, objectName)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error)
  },
)

export const saveGrid = createAsyncThunk<GridServerResponse, GridSaveParams, ThunkApi>(
  '[GRID] VIEW',
  async ({ formName, objectName, gridStates }, { extra, rejectWithValue }) => {
    const result = await extra.api.grids.save(formName, objectName, gridStates)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error)
  },
)
